var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"image-modal":""},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"image-holder"},[_c('img',{attrs:{"src":_vm.options.img}})])])}
var staticRenderFns = []

export { render, staticRenderFns }